import "intl-tel-input/styles";
import React, { useContext, useState } from "react";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { instagramMask } from "../../../services/Masks";
import { validateHex } from "../../../services/MasksValidations";
import { unmaskInstagram } from "../../../services/Unmasks";
import ColorDisplay from "../../ColorDisplay/ColorDisplay";
import ColorPicker from "../../ColorPicker/ColorPicker";
import { Input } from "../../Input";
import NumeroInternacional from "../../IntlTelInput/intl-tel-input";
import MockupCatalogo from "../../Mockups/MockupCatalogo/MockupCatalogo";
import Titulo from "../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import ModalRelativo from "../../ModalRelativo/ModalRelativo";
import Modal from "../../../components/Modal/Modal";
import ModalSugestoesCores from "../../Modal/ModalSugestoesCores/ModalSugestoesCores";
import Quill from "../../Quill/Quill";
import { Select } from "../../Select";
import ImageUploadLogo from "../../Upload/ImageUploadLogo/ImageUploadLogo";
import { InformacoesDaMarcaContainer, ContainerSugestaoCoresIa } from "./styles";
import "intl-tel-input/styles";
import SugestoesCoresIA from "../../SugestoesCoresIA/SugestoesCoresIA";
import { Button } from "../../../components/Button/index";
import { ReactComponent as DescricaoIA } from "../../../assets/newImages/icons/descricao-ia.svg";

interface InformacoesDaMarcaProps {
  configIn: "empresa" | "configuracoes";
}

const InformacoesDaMarca: React.FC<InformacoesDaMarcaProps> = ({
  configIn,
}) => {
  const {
    configuracoes,
    setConfiguracoes,
    sugestoesCores,
    loadingSugestoes,
    mostrarSugestoes,
    setMostrarSugestoes,
    logoExistente,
    previewCores,
    previewCor: previewCorContext,
    aplicarSugestaoCor,
    rejeitarSugestoes,
    limparPreview,
    obterSugestoesCores
  } = useContext(ConfiguracoesContext);

  const [quillLength, setQuillLength] = useState(0);

  const [cor_primariaAux, setCor_primariaAux] = useState(
    configuracoes.catalogo.cor_primaria
  );
  const [cor_secundariaAux, setCor_secundariaAux] = useState(
    configuracoes.catalogo.cor_secundaria
  );

  const [opcoesRamosDeAtividades, setOpcoesRamosDeAtividades] = useState([
    { value: "Acessórios e joias", name: "Acessórios e joias" },
    { value: "Alimentos e bebidas", name: "Alimentos e bebidas" },
    { value: "Arte e artesanato", name: "Arte e artesanato" },
    { value: "Beleza e cuidados pessoais", name: "Beleza e cuidados pessoais" },
    { value: "Brinquedos e jogos", name: "Brinquedos e jogos" },
    { value: "Material de limpeza", name: "Material de limpeza" },
    { value: "Moda e vestuário", name: "Moda e vestuário" },
    { value: "Móveis e decoração", name: "Móveis e decoração" },
    { value: "Papelaria e escritório", name: "Papelaria e escritório" },
    { value: "Pet shop", name: "Pet shop" },
    { value: "Saúde e suplementos", name: "Saúde e suplementos" },
    {
      value: "Utensílios e objetos em geral",
      name: "Utensílios e objetos em geral",
    },
    { value: "Outro", name: "Outro" },
  ]);

  const handleImageUpload = (base64: string, imagem: string, size: number) => {
    setConfiguracoes({
      ...configuracoes,
      dados_empresa: {
        ...configuracoes.dados_empresa,
        informacoes_gerais: {
          ...configuracoes.dados_empresa.informacoes_gerais,
          logotipo: {
            base64: base64,
            imagem: imagem,
            size: size,
          },
        },
      },
    });
  };

  const handleInformacoesGeraisChange = (newValue: string, name?: string) => {
    setConfiguracoes({
      ...configuracoes,
      dados_empresa: {
        ...configuracoes.dados_empresa,
        informacoes_gerais: {
          ...configuracoes.dados_empresa.informacoes_gerais,
          [name!]: newValue,
        },
      },
    });
  };

  const handleRedesSociaisChange = (newValue: string, name?: string) => {
    setConfiguracoes({
      ...configuracoes,
      dados_empresa: {
        ...configuracoes.dados_empresa,
        redes_sociais: {
          ...configuracoes.dados_empresa.redes_sociais,
          [name!]: newValue,
        },
      },
    });
  };

  const handleColorChange = (cor: string, numero: number) => {
    const newCatalogo = {
      ...configuracoes.catalogo,
      cor_primaria: numero === 1 ? cor : configuracoes.catalogo.cor_primaria,
      cor_secundaria:
        numero === 2 ? cor : configuracoes.catalogo.cor_secundaria,
    };

    const isDisabled =
      !validateHex(newCatalogo.cor_primaria) || !validateHex(newCatalogo.cor_secundaria) ||
      newCatalogo.cor_primaria === newCatalogo.cor_secundaria;

    setConfiguracoes({ ...configuracoes, catalogo: newCatalogo });
    setDisabled(isDisabled);
  };

  const handleSugerirCoresIA = async () => {
    // Verificar se tem logo antes de sugerir cores
    const temLogo = configuracoes?.dados_empresa?.informacoes_gerais?.logotipo;
    if (!temLogo) {
      alert("Por favor, faça upload de uma logo primeiro");
      return;
    }

    // Abrir modal e buscar sugestões
    setModalSugestoesIA(true);
    await obterSugestoesCores();
  };

  const handleAplicarSugestao = (cor_primaria: string, cor_secundaria: string) => {
    aplicarSugestaoCor(cor_primaria, cor_secundaria);
    setModalSugestoesIA(false);
    limparPreview();
  };

  const handleFecharModal = () => {
    setModalSugestoesIA(false);
    rejeitarSugestoes();
    limparPreview();
  };

  const handlePreviewSugestao = (cor_primaria: string, cor_secundaria: string) => {
    setPreviewCoresModal({ cor_primaria, cor_secundaria });
  };

  const [colorPicker1, setColorPicker1] = useState(false);
  const [colorPicker2, setColorPicker2] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [modalSugestoesIA, setModalSugestoesIA] = useState(false);

  const [previewCoresModal, setPreviewCoresModal] = useState<{ cor_primaria: string, cor_secundaria: string } | null>(null);
  const [btnVisualizarAtivo, setBtnVisualizarAtivo] = useState<number | null>(null);

  const { theme } = useTheme();

  // Secundária branca não pode virar borda: as duas amostras sumiriam no fundo.
  const corBordaAmostra =
    typeof configuracoes.catalogo.cor_secundaria === "string" &&
    configuracoes.catalogo.cor_secundaria.toUpperCase() !== "#FFFFFF"
      ? configuracoes.catalogo.cor_secundaria
      : "#A7A7A7";

  const configuracoesComPreview = React.useMemo(() => {
    if (previewCoresModal || previewCores) {
      return {
        ...configuracoes,
        catalogo: {
          ...configuracoes.catalogo,
          cor_primaria: previewCoresModal?.cor_primaria || previewCores?.cor_primaria || configuracoes.catalogo.cor_primaria,
          cor_secundaria: previewCoresModal?.cor_secundaria || previewCores?.cor_secundaria || configuracoes.catalogo.cor_secundaria
        }
      };
    }
    return configuracoes;
  }, [configuracoes, previewCoresModal, previewCores]);

  return (
    <>
      <InformacoesDaMarcaContainer configIn={configIn} theme={theme}>
        <div className="InformacoesDaMarca">
          <div className="informacoes">
            <Titulo
              titulo="Informações da marca"
              subtitulo="Sua empresa"
              justifyContent="flex-start"
              padding="0"
            />
            <div className="texto-descricao fonteTexto">
              Preencha as informações da marca de forma clara e estratégica para aumentar a credibilidade e facilitar o acesso dos clientes aos dados do seu negócio.
            </div>
            <div className="inputs-container">
              <div className="input-container">
                <Input
                  required={true}
                  onChange={handleInformacoesGeraisChange}
                  type={"text"}
                  name="nome"
                  value={configuracoes.dados_empresa.informacoes_gerais.nome}
                  placeholder={"Nome da Marca"}
                  error={""}
                  maxLength={30}
                  debounceTime={1000}
                  showMaxLength={false}
                ></Input>
              </div>
              <div className="select-container">
                <Select
                  placeholder="Ramo de Atividade"
                  options={opcoesRamosDeAtividades}
                  value={
                    configuracoes.dados_empresa.informacoes_gerais
                      .ramo_atividade
                  }
                  onChange={handleInformacoesGeraisChange}
                  name={"ramo_atividade"}
                  required={true}
                />
              </div>
              <div className="input-container">
                <Quill
                  className="quill-editor-2"
                  formats={["bold", "italic", "underline", "list"]}
                  placeholder={"Descrição"}
                  required={false}
                  maxLength={200}
                  value={
                    configuracoes.dados_empresa.informacoes_gerais.descricao
                  }
                  onChange={(newContent) => {
                    setConfiguracoes({
                      ...configuracoes,
                      dados_empresa: {
                        ...configuracoes.dados_empresa,
                        informacoes_gerais: {
                          ...configuracoes.dados_empresa.informacoes_gerais,
                          descricao: newContent,
                        },
                      },
                    });
                  }}
                />
              </div>
              <div className="input-container">
                <div className="whatsapp">
                  <NumeroInternacional
                    type={"tel"}
                    required={true}
                    name={"tel"}
                    value={configuracoes.dados_empresa.redes_sociais.whatsapp}
                    setConfiguracoes={setConfiguracoes}
                  />
                </div>
                <div className="insta">
                  <Input
                    required={true}
                    onChange={handleRedesSociaisChange}
                    type={"text"}
                    name="instagram"
                    mask={{
                      mask: instagramMask,
                      unmask: unmaskInstagram,
                    }}
                    value={configuracoes.dados_empresa.redes_sociais.instagram}
                    placeholder={"@Instagram"}
                    error={""}
                    maxLength={30}
                    showMaxLength={false}
                  >
                  </Input>
                </div>
              </div>
              <div className="perfil-da-marca">
                <div className="logo-colors-container">
                  <div className="image-upload">
                    <ImageUploadLogo
                      configIn={configIn}
                      value={
                        configuracoes.dados_empresa.informacoes_gerais.logotipo[
                          "base64"
                        ]
                          ? configuracoes.dados_empresa.informacoes_gerais
                            .logotipo["base64"]
                          : configuracoes.dados_empresa.informacoes_gerais
                            .logotipo
                      }
                      onChange={(base64, imagem, size) => {
                        handleImageUpload(base64, imagem, size);
                      }}
                    ></ImageUploadLogo>
                  </div>
                  <div className="colors-section">
                    <div className="cores fonteTexto">
                      Cores
                    </div>
                    <div className="color-item">
                      <span className="color-label fonteRotulos">Cor do botão</span>
                      <ColorDisplay
                        cor={configuracoes.catalogo.cor_primaria}
                        corBorda={corBordaAmostra}
                        onClick={() => setColorPicker1(true)}
                      />
                    </div>
                    <div className="color-item">
                      <span className="color-label fonteRotulos">Cor do texto</span>
                      <ColorDisplay
                        cor={configuracoes.catalogo.cor_secundaria}
                        corBorda={corBordaAmostra}
                        onClick={() => setColorPicker2(true)}
                      />
                    </div>
                    <div
                      className="gerar-descricao-ia fonteRotulos"
                      onClick={handleSugerirCoresIA}
                      style={{ cursor: 'pointer' }}>
                      <DescricaoIA className="descricao-ia" />
                      <span>Sugerir cores com IA</span>
                    </div>
                  </div>
                </div>
                {colorPicker1 && (
                  <ModalRelativo
                    normalModal={configIn === "configuracoes" ? true : false}
                    width="40rem"
                    cancelar={true}
                    background="none"
                    isOpen={colorPicker1}
                    setIsOpen={setColorPicker1}
                    botaoConfirmar="Salvar"
                    titulo={"Cor primária"}
                    subtitulo={"Menu, botões e ícones"}
                    top="20rem"
                    left="30rem"
                    disabled={disabled}
                    onUseEffect={() => {
                      setCor_primariaAux(configuracoes.catalogo.cor_primaria);
                    }}
                    onCancel={() => {
                      setConfiguracoes({
                        ...configuracoes,
                        catalogo: {
                          ...configuracoes.catalogo,
                          cor_primaria: cor_primariaAux,
                        },
                      });
                    }}
                    disabledMessage={
                      "Preencha um código hexadecimal válido"
                    }
                  >
                    <ColorPicker
                      color={configuracoes.catalogo.cor_primaria}
                      onChange={(cor: any) => {
                        handleColorChange(cor.hex, 1);
                      }}
                      onChangeInput={(cor: string) => {
                        handleColorChange(cor, 1);
                      }}
                    />
                  </ModalRelativo>
                )}
                {colorPicker2 && (
                  <ModalRelativo
                    normalModal={configIn === "configuracoes" ? true : false}
                    width="40rem"
                    cancelar={true}
                    background="none"
                    isOpen={colorPicker2}
                    setIsOpen={setColorPicker2}
                    botaoConfirmar="Salvar"
                    titulo={"Cor secundária"}
                    subtitulo={"Textos e ícones"}
                    top="20rem"
                    left="30rem"
                    disabled={disabled}
                    onUseEffect={() => {
                      setCor_secundariaAux(
                        configuracoes.catalogo.cor_secundaria
                      );
                    }}
                    onCancel={() => {
                      setConfiguracoes({
                        ...configuracoes,
                        catalogo: {
                          ...configuracoes.catalogo,
                          cor_secundaria: cor_secundariaAux,
                        },
                      });
                    }}
                    disabledMessage={
                      validateHex(configuracoes.catalogo.cor_secundaria)
                        ? "Não há contraste suficiente"
                        : "Preencha um código hexadecimal válido"
                    }
                  >
                    <ColorPicker
                      color={configuracoes.catalogo.cor_secundaria}
                      onChange={(cor: any) => {
                        handleColorChange(cor.hex, 2);
                      }}
                      onChangeInput={(cor: string) => {
                        handleColorChange(cor, 2);
                      }}
                    />
                  </ModalRelativo>
                )}
              </div>
            </div>
          </div>
          <div className="mockup-container">
            <MockupCatalogo
              configuracoes={React.useMemo(() => previewCores ? {
                ...configuracoes,
                catalogo: {
                  ...configuracoes.catalogo,
                  cor_primaria: previewCores.cor_primaria,
                  cor_secundaria: previewCores.cor_secundaria
                }
              } : configuracoes, [configuracoes, previewCores])}
            />
          </div>
        </div>
      </InformacoesDaMarcaContainer>

      <Modal
        isOpen={modalSugestoesIA}
        setModal={setModalSugestoesIA}
        width="150rem"
        maxWidth="99vw"
        align="center"
        backdrop="static"
        justify="center"
        padding="24px"
        animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
        margin="0rem 2rem 0rem 2rem"
      >
        <ContainerSugestaoCoresIa theme={theme}>
          <div className="conteudoModalSugestoesCores">
            <div className="sugestoes">
              <div className="cabecalho">
                <div className="titulo fonteTitulo">
                  Sugestão de cor com IA
                </div>
                <div className="texto fonteTexto">
                  Sugestão de cores baseadas no logotipo da sua marca. Você pode visualizar como ficará no mockup ao lado e ao aplicar, ainda poderá editar manualmente as cores.
                </div>
              </div>
              <div className="linha"></div>
              <div className="paletasSugeridas">
                {loadingSugestoes ? (
                  <div className="loadingMessage fonteTexto">
                    Analisando sua logo e gerando sugestões de cores...
                  </div>
                ) : sugestoesCores?.cores_sugeridas?.length > 0 ? (
                  <>
                    <div className="grupoPaletas">
                      {sugestoesCores.cores_sugeridas.slice(0, 4).map((sugestao, index) => (
                        <div className={`paleta ${btnVisualizarAtivo === index ? 'ativo' : ''}`} key={index}>
                          <span className="tituloPaleta fonteTexto">Paleta de cor {index + 1}</span>
                          <div className="cores">
                            <div className="cor">
                              <div
                                className="bgCor primaria"
                                style={{ backgroundColor: sugestao.cor_primaria }}
                              ></div>
                              <span className="hexa fonteHex">{sugestao.cor_primaria}</span>
                            </div>
                            <div className="cor">
                              <div
                                className="bgCor secundaria"
                                style={{ backgroundColor: sugestao.cor_secundaria }}
                              ></div>
                              <span className="hexa fonteHex">{sugestao.cor_secundaria}</span>
                            </div>
                          </div>
                          <div
                            className={`fonteTexto btnVisualizar ${btnVisualizarAtivo === index ? 'ativo' : ''}`}
                            onClick={() => {
                              if (btnVisualizarAtivo === index) {
                                setBtnVisualizarAtivo(null);
                                setPreviewCoresModal(null);
                              } else {
                                setBtnVisualizarAtivo(index);
                                setPreviewCoresModal({
                                  cor_primaria: sugestao.cor_primaria,
                                  cor_secundaria: sugestao.cor_secundaria
                                });
                              }
                            }}
                          >
                            {btnVisualizarAtivo === index ? 'Visualizando' : 'Visualizar'}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="semSugestoes fonteTexto">
                      Nossa inteligência artificial está passando por instabilidade no momento. Tente novamente em alguns instantes.
                  </div>
                )}
              </div>
              <div className="botoes fonteTexto">
                <div
                  className="cancelar"
                  onClick={() => {
                    handleFecharModal();
                  }}

                >
                  Voltar
                </div>
                <Button
                  title="Aplicar"
                  onClick={() => {
                    if (btnVisualizarAtivo !== null && sugestoesCores?.cores_sugeridas?.[btnVisualizarAtivo]) {
                      const sugestaoSelecionada = sugestoesCores.cores_sugeridas[btnVisualizarAtivo];
                      handleAplicarSugestao(sugestaoSelecionada.cor_primaria, sugestaoSelecionada.cor_secundaria);
                    }
                  }}
                  disabled={btnVisualizarAtivo === null || loadingSugestoes}
                />
              </div>
            </div>
            <div className="mockup">
              <MockupCatalogo
                configuracoes={configuracoesComPreview}
                mostrarFooter={false}
              />
            </div>
          </div>
        </ContainerSugestaoCoresIa>
      </Modal>
    </>
  );
};
export default InformacoesDaMarca;
